<template>
    <div class="tab-menu-wrap arabic">
        <ul class="tab-menu" v-if="$store.getters.getHost != 'H0009'">
            <li class="tab-menu__item"><router-link :to="`/${$store.getters.getLang}/centerList`"> تعريف المركز </router-link></li>
            <li class="tab-menu__item active"><router-link :to="`/${$store.getters.getLang}/doctorList`"> بحث عن الفريق الطبي </router-link></li>
        </ul>
        <ul class="tab-menu" v-else>
            <li :class="{'tab-menu__item': true, 'active': viewType == 'doctor'}">
                <a href="javascript:;" @click="changeList('doctor')"> 교수/의사 </a>
            </li>
            <li :class="{'tab-menu__item': true, 'active': viewType == 'nurse'}">
                <a href="javascript:;" @click="changeList('nurse')"> 간호파트 </a>
            </li>
            <li :class="{'tab-menu__item': true, 'active': viewType == 'supporter'}">
                <a href="javascript:;" @click="changeList('supporter')"> 진료지원/연구파트 </a>
            </li>
        </ul>
    </div>
    <div class="contents">
        <div class="full-width info bg-pink ar lang arabic">
            <div class="word-search">
                <label class="word-search__input">
                    <input type="text" class="input" placeholder="&nbsp;"  v-model="drName" @keyup.enter="getDoctorList()">
                    <div class="btn">
                        <button type="button" @click="getDoctorList()"><img src="@/assets/resource/icon/search.svg" alt=""></button>
                    </div>
                </label>
                <!-- <div class="word-search__btn type2">
                    <h5 class="title02">بحث بالحروف الأولى</h5>
                    <ul class="word-search__list">
                        <li :class="{'word-search__item': true, 'active': !searchChosung}">
                            <button type="button" class="btn" @click="[searchConsonant('')]">الكل</button>
                        </li>
                        <li class="word-search__item" :class="{'active': searchChosung === consonant.searchText }" v-for="(consonant, index) in consonantList" :key="index">
                            <button type="button" class="btn" @click="searchConsonant(consonant.searchText)" :class="consonant.disable">{{ consonant.cho }}</button>
                        </li>
                    </ul>
                </div> -->
            </div>
        </div>

        <ar_DoctorCard :doctorList="viewList"/>
    </div>
</template>

<script>
import doctors, {getNurse, getSupporter, getConsonant} from '@/doctor/doctors';

export default {
    components: {
    },
    data() {
        return {
            drName: this.$route.query.drName || '',
            chosungs: '',
            doctorList: [],
            consonantList: [],
            searchChosung: '',
            viewType: 'doctor',
            viewList: [],
        }
    },
    methods: {
        getDoctorConsonant() {
            const param = {
                hospId: this.$store.getters.getHost,
                deptType: 1
            }

            if(this.drName){
                param.drName = this.drName
            }
            
            this.axios.get(this.api.doctor.doctorCons, {params: param})
                .then(res => {
                    this.consonantList = [
                        { cho: 'ㄱ~ㄷ', disable: 'disable', choList: ['ㄱ', 'ㄴ', 'ㄷ'], searchText: 'ㄱ,ㄴ,ㄷ' },
                        { cho: 'ㄹ~ㅂ', disable: 'disable', choList: ['ㄹ', 'ㅁ', 'ㅂ'], searchText: 'ㄹ,ㅁ,ㅂ' },
                        { cho: 'ㅅ~ㅊ', disable: 'disable', choList: ['ㅅ', 'ㅇ', 'ㅈ', 'ㅊ'], searchText: 'ㅅ,ㅇ,ㅈ,ㅊ' },
                        { cho: 'ㅋ~ㅎ', disable: 'disable', choList: ['ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'], searchText: 'ㅋ,ㅌ,ㅍ,ㅎ' },
                    ]
                    for (let i of this.consonantList) {
                        for (let j of res.data.list) {
                            if (i.choList.includes(j)) {
                                i.disable = ''
                            }
                        }
                    }
                })
        },
        getDoctorList(chosungs){
            this.$router.replace({
                path: this.$route.path,
                query: {drName: this.drName}
            })

            if(this.drName){
                this.searchChosung = ''
                this.currentNum = 1
            }

            if(this.viewType == 'nurse'){
                this.viewList = getNurse(this.drName, chosungs)
                this.consonantList = getConsonant(this.drName ? this.viewList : doctors.nurse)
                return
            }
            if(this.viewType == 'supporter'){
                this.viewList = getSupporter(this.drName, chosungs)
                this.consonantList = getConsonant(this.drName ? this.viewList : doctors.supporter)
                return
            }
            
            this.chosungs = chosungs ? chosungs : ''
            const param = {
                startIndex: 1,
                drName: this.drName,
                pageRow: 100,
                langCd: this.$store.getters.getLang,
                hospId: this.$store.getters.getHost,
                chosungs: this.chosungs
            }
            this.axios.get(this.api.doctor.doctorList, {params: param})
            .then(res => {
                this.doctorList = []
                this.viewList = []
                if(res.data.doctorTotCnt > 0){
                    this.doctorList = res.data.doctorList
                    this.viewList = this.doctorList
                }
                if(!chosungs){
                    this.getDoctorConsonant()
                }
            })
        },
        searchConsonant(consonant) {
            this.searchChosung = consonant
            this.currentNum = 1
            this.getDoctorList(consonant)
        },
        changeList(type){
            this.viewType = type
            this.searchChosung = ''
            this.currentNum = 1
            this.getDoctorList()
        }
    },
    mounted() {
        this.getDoctorConsonant()
        this.getDoctorList()
    },
}
</script>